import type { QueryClient } from "@tanstack/react-query";
import { redirect } from "@tanstack/react-router";
import type { Operator } from "../lib/api-types";
import { paths } from "../lib/endpoints";
import { apiRequest } from "../lib/api";
import { meQuery, meQueryKey } from "./queries";

/** Route guard: resolves the operator or redirects to /login. */
export async function requireOperator(queryClient: QueryClient): Promise<Operator> {
  const operator = await queryClient.ensureQueryData(meQuery);
  if (!operator) {
    // TanStack Router requires throwing redirect() from beforeLoad.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: "/login" });
  }
  return operator;
}

/**
 * Ends the session on the server, then clears every cached query so no data from this
 * operator stays in memory. A failed logout request still clears the local state.
 */
export async function signOut(queryClient: QueryClient): Promise<void> {
  try {
    await apiRequest<{ loggedOut: boolean }>(paths.logout, { method: "POST" });
  } catch (error: unknown) {
    console.warn("sign-out request failed; clearing local state anyway", error);
  }
  queryClient.setQueryData(meQueryKey, null);
  queryClient.clear();
}
